import { Modal } from 'shared-components';
import { Button, Text } from '@chakra-ui/react';
import { useTranslation } from "react-i18next";

export interface IProps {
  onClose: () => void;
}

const IntakeChangeConflictModal = (props: IProps) => {
    const { t } = useTranslation('dialogs');
  const { onClose } = props;

  return (
    <Modal
      id="update-intake-conflict"
      show={true}
      title={t('dialogs:actionNotPermitted')}
      onClose={onClose}
      maxWidthPx={630}
      backgroundColor={'#4a535b'}
      textColor={'#fff'}
      headerFontSize={18}
      headerMargin={22}
      paddingTop={20}
      footer={
        <Button id="submit-close-button" onClick={onClose} size="lg" variant="solid">
          Return to CAS Checklist
        </Button>
      }
    >
      <Text mb={0}>
        {t('dialogs:theNewStartDateFallsWithinADiffe')}
                    </Text>
    </Modal>
  );
};

export default IntakeChangeConflictModal;
